// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"592":"1f4b1d80","696":"5424ed1c","729":"5516a991","970":"08fbf6f5"}[chunkId] + ".chunk.css";
};